


//////////////////
// WEBPACK FOOTER
// ../~/node-libs-browser/mock/empty.js
// module id = 1673
// module chunks = 2